export default "__VITE_ASSET__Dw3sO8yo__"